import React from 'react';
import PropTypes from 'prop-types';
import * as immutable from 'immutable';
import Loading from 'components/pure/utils/Loading';
import './DepartmentList.styl';
import DepartmentListItem from 'components/admin/topics/DepartmentListItem';
import NewFilterWordProfilesInAccount from 'records/admin/topics/NewFilterWordProfilesInAccount';
import {ProfileEditorKey} from 'stores/admin/AdminFilterWordProfilePageStore';
import {getQueryParam} from 'utils/getQueryParam';

/**
 * List of expandable departments, allowing editing of profiles for the department and the teams
 * it contains, for the topics page.
 */
export default class DepartmentList extends React.PureComponent {
  static propTypes = {
    departments: PropTypes.instanceOf(immutable.List).isRequired,
    editable: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    expandedDepartmentIds: PropTypes.instanceOf(immutable.Set).isRequired,
    expandedTeamIds: PropTypes.instanceOf(immutable.Set).isRequired,
    idToProfileMap: PropTypes.instanceOf(immutable.Map).isRequired,
    loading: PropTypes.bool.isRequired,
    profileDepartmentAndTeamUsage: PropTypes.instanceOf(immutable.Map).isRequired,
    profileEditorKey: PropTypes.instanceOf(ProfileEditorKey),
    profilesInAccount: PropTypes.instanceOf(NewFilterWordProfilesInAccount).isRequired,
    topicsInAccount: PropTypes.instanceOf(immutable.List).isRequired,
  };

  render() {
    const {
      departments,
      editable,
      error,
      expandedDepartmentIds,
      expandedTeamIds,
      idToProfileMap,
      loading,
      profileDepartmentAndTeamUsage,
      profileEditorKey,
      profilesInAccount,
      topicsInAccount,
      location,
    } = this.props;
    // Allow links to a specific department.
    const openDepartmentId = getQueryParam(location, 'openDepartmentId');

    const content = loading ? (
      <Loading />
    ) : error ? (
      <p>There was an error loading the data.</p>
    ) : (
      departments.map(department => (
        <DepartmentListItem
          key={department.departmentId}
          department={department}
          editable={editable}
          expanded={expandedDepartmentIds.has(department.id)}
          expandedTeamIds={expandedTeamIds}
          initiallyExpanded={department.departmentId === openDepartmentId}
          idToProfileMap={idToProfileMap}
          profileDepartmentAndTeamUsage={profileDepartmentAndTeamUsage}
          profileEditorKey={profileEditorKey}
          profilesInAccount={profilesInAccount}
          topicsInAccount={topicsInAccount}
        />
      ))
    );
    // TODO add collapse-all link at the top if any departments are expanded (call
    //  AdminFilterWordProfilePageActions.collapseAllDepartments on click).
    return (
      <div className="admin-topics-department-list">
        <h2>Department Configuration</h2>
        {content}
      </div>
    );
  }
}
